import addError from './addError';
import resetErrors from './resetErrors';

export const ErrorsActions = {
  resetErrors,
  addError,
};

export default ErrorsActions;
